import React, { useState, useRef, useEffect, useLayoutEffect, useCallback } from "react";
import { makeStyles } from "@mui/styles";
import StatementFilter from "./StatementFilter";
import StatementGrid from "./StatementGrid";
import ListPageHeader from "../../utilities/ListPageHeader";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const useEnhancedEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

const StatementOfAccounts = () => {
    const useStyles = makeStyles({
        customHeaderCell: {
            fontSize: '6px',
        }
    })

    const classes = useStyles;
    const [rowData, setRowData] = useState([]);
    const [invoice, setInvoice] = useState('')
    const [customer, setCustomer] = useState();
    const [companyName, setCompanyName] = useState('');
    const [loadingDate, setLoadingDate] = useState('');
    const [period, setPeriod] = useState('');
    const [cutOffDate, setCutOffDate] = useState('');
    const [teritory, setTeritory] = useState('');
    const [commissionName, setCommissionName] = useState('');
    const [showPaginationDropdown, setShowPaginationDropdown] = useState(false);
    const [viewOptions, setViewOptions] = useState('');
    const [showPrintComponent, setShowPrintComponent] = useState(false);

    const url = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.statementOfAccount}`;
    const urlLedgerSearch = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.ledgerBooksSearch}`;

    const gridRef = useRef();
    const [gridApi, setGridApi] = useState(null);

    const onGridReady = (params) => {
        setGridApi(params.api);
    };

    const handleSearchData = async () => {

        if (invoice) {
            try {
                const list = await OAuthService.getList(urlLedgerSearch + `/findbyPiNumber?piNumber=${invoice}`);
                setRowData(list.data);
            } catch (error) {
                setError(error.message);
            }
        }
        else if (customer) {
            try {
                const list = await OAuthService.getList(urlLedgerSearch + `/findbyCustNum?custNum=${customer}`);
                setRowData(list.data);
            } catch (error) {
                setError(error.message);
            }
        }
        else if (companyName) {
            try {
                const list = await OAuthService.getList(urlLedgerSearch + `/findbyCustName?custName=${companyName}`);
                setRowData(list.data);
            } catch (error) {
                setError(error.message);
            }
        }
        else if (commissionName) {
            try {
                const list = await OAuthService.getList(urlLedgerSearch + `/findbyCommissionName?commissionName=${commissionName}`);
                setRowData(list.data);
            } catch (error) {
                setError(error.message);
            }
        }
        else {
            try {
                // const list = await OAuthService.getList(url + `/getStatementOfAccount?startLoadingDate=${loadingDate}&toLoadingDate=${period}&cutoffDate=${cutOffDate}`);
                // const list = await OAuthService.getList(`${url}/findAllHeadAccount`);
                const list = await OAuthService.getList(`http://localhost:8060/fin/api/chartOfAccount/findAllHeadAccount`);
                // setRowData(list.data);
                setRowData(list);
            } catch (error) {
                setError(error.message);
            }
        }
    };

    const onBtExport = useCallback(() => {
        const params = {
            fileName: "StatementOfAccounts.xlsx",
            sheetName: "Statement Of Accounts",
        };
        gridRef.current.api.exportDataAsExcel(params);
    }, []);

    // const handleSearchCompany = useCallback((year) => {

    //     var countryFilterComponent = gridRef.current.api.getFilterInstance("year");
    //     countryFilterComponent.setModel({ values: [year] });
    //     gridRef.current.api.onFilterChanged();
    // }, []);

    const handleSearchInvoice = useCallback((invoice) => {
        setInvoice(invoice)
    }, []);

    const handleSearchCustomer = useCallback((customerNo) => {
        setCustomer(customerNo)
    }, []);

    const handleName = useCallback((name) => {
        setCompanyName(name)
        // var countryFilterComponent = gridRef.current.api.getFilterInstance("year");
        // countryFilterComponent.setModel({ values: [year] });
        // gridRef.current.api.onFilterChanged();
    }, []);

    const handleLoadingDate = useCallback((loadingDate) => {
        setLoadingDate(loadingDate);
    }, []);

    const handleSearchPeriod = useCallback((period) => {
        setPeriod(period);
    }, []);

    const handleDate = useCallback((cutoffDate) => {
        setCutOffDate(cutoffDate);
    }, []);

    const handleTeritory = useCallback(() => {
        // var countryFilterComponent = gridRef.current.api.getFilterInstance("year");
        // countryFilterComponent.setModel(null);
        // gridRef.current.api.onFilterChanged();
    }, []);

    const handleCommissionName = useCallback((name) => {
        setCommissionName(name)
        // var ageFilterComponent = gridRef.current.api.getFilterInstance("period");
        // ageFilterComponent.setModel({
        //     type: "lessThanOrEqual",
        //     filter: period,
        // });
        // gridRef.current.api.onFilterChanged();
    }, []);

    const handleViewOpion = useCallback((option) => {
        setViewOptions(option);
    }, []);

    const handleSearch = useCallback((value) => {
        gridRef.current.api.setQuickFilter(value);
    }, []);

    const onBtPrint = useCallback(() => {
        setShowPrintComponent(true);
        const api = gridRef.current.api;
        setPrinterFriendly(api);
        setTimeout(function () {
            print();
            setNormal(api)
        }, 2000);
    }, [print]);

    const setPrinterFriendly = (api) => {
        const eGridDiv = document.getElementById('chartOfAccountGrid');
        eGridDiv.style.width = '';
        eGridDiv.style.height = '';
        api.sizeColumnsToFit();
        api.setDomLayout('print');
    }

    function setNormal(api) {
        const eGridDiv = document.getElementById('chartOfAccountGrid');
        eGridDiv.style.width = '100%';
        eGridDiv.style.height = 'auto';
        api.setDomLayout();
    }

    const [isFullScreen, setIsFullScreen] = useState(false);
    const elementGridRef = useRef(null);

    useEnhancedEffect(() => {
        document.onfullscreenchange = () =>
            setIsFullScreen(document[getBrowserFullscreenElementProp()] != null);

        return () => {
            document.onfullscreenchange = undefined;
        };
    });

    function getBrowserFullscreenElementProp() {
        if (typeof document.fullscreenElement !== 'undefined') {
            return 'fullscreenElement';
        }
        if (typeof document.mozFullScreenElement !== 'undefined') {
            return 'mozFullScreenElement';
        }
        if (typeof document.msFullscreenElement !== 'undefined') {
            return 'msFullscreenElement';
        }
        if (typeof document.webkitFullscreenElement !== 'undefined') {
            return 'webkitFullscreenElement';
        }
        throw new Error('fullscreenElement is not supported by this browser');
    }

    /* View in fullscreen */
    function openFullscreen() {
        // const elem = document.documentElement;
        const elem = elementGridRef;

        if (elem.current.requestFullscreen) {
            elem.current.requestFullscreen();
        } else if (elem.current.mozRequestFullScreen) {
            /* Firefox */
            elem.current.mozRequestFullScreen();
        } else if (elem.current.webkitRequestFullscreen) {
            /* Chrome, Safari and Opera */
            elem.current.webkitRequestFullscreen();
        } else if (elem.current.msRequestFullscreen) {
            /* IE/Edge */
            elem.current.msRequestFullscreen();
        }
    }

    /* Close fullscreen */
    function closeFullscreen() {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
            /* Firefox */
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            /* Chrome, Safari and Opera */
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            /* IE/Edge */
            document.msExitFullscreen();
        }
    }

    function toggleFullScreen() {
        if (
            document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement
        ) {
            closeFullscreen();
        } else {
            openFullscreen();
        }
    }

    return (
        <>
            <ListPageHeader
                componentName="Statement of Accounts"
                onBtExport={onBtExport}
                pageName="Statement of Accounts"
                gridRef={gridRef}
                showPaginationDropdown={showPaginationDropdown}
                onBtPrint={onBtPrint}
            />
            <div className="px-20 pb-16 pt-16">
                <Accordion defaultExpanded={true}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        sx={{ justifyContent: 'center' }}
                        className={'justify-center'}
                    >
                        <Typography className="w-full text-center text-xl">Select Fields</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <StatementFilter
                            // handleSearchCompany={handleSearchCompany}
                            handleSearchInvoice={handleSearchInvoice}
                            handleSearchCustomer={handleSearchCustomer}
                            handleName={handleName}
                            handleLoadingDate={handleLoadingDate}
                            handleDate={handleDate}
                            handleTeritory={handleTeritory}
                            handleSearchPeriod={handleSearchPeriod}
                            handleCommissionName={handleCommissionName}
                            handleOptionChange={handleViewOpion}
                            handleSearch={handleSearchData}
                            toggleFullScreen={toggleFullScreen}
                        />
                    </AccordionDetails>
                </Accordion>
            </div>
            <div className="h-full pr-24 pl-24 w-full" id='myGrid' ref={elementGridRef}>
                {/* {rowData.length > 0 && */}
                <StatementGrid
                    rowData={rowData}
                    gridRef={gridRef}
                    cutoffDate={cutOffDate}
                    viewOptions={viewOptions}
                />
                {/* } */}
            </div>
            <style>
                {`
            @media print {
  body * {
    visibility: hidden;
  }
  #myGrid, #myGrid * {
    visibility: visible;
  }
  #myGrid {
    position: absolute;
    left: 0;
    top: 0;
  }
}
`}
            </style>
        </>
    );
};

export default StatementOfAccounts;
